import { useMemo } from "react";
import { nodeDefList } from "src/nodes";
import { NodeData, NodeDefinition, NodeType } from "src/types/node.types";

export function useNodeDefs(term: string) {
  const result = useMemo(() => {
    const terms = term.toLowerCase().split(/\W/);
    const filtered = nodeDefList.filter((nodeDef) => {
      const lookup = [
        nodeDef.displayName.toLowerCase(),
        (nodeDef.description || "").toLowerCase(),
      ];
      return terms.every((term) => lookup.some((str) => str.includes(term)));
    });

    return filtered;
  }, [term]);

  return result as NodeDefinition<NodeType, NodeData>[];
}
